import { render, staticRenderFns } from "./inform-details.vue?vue&type=template&id=f4452166&scoped=true"
import script from "./inform-details.vue?vue&type=script&lang=js"
export * from "./inform-details.vue?vue&type=script&lang=js"
import style0 from "./inform-details.vue?vue&type=style&index=0&id=f4452166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4452166",
  null
  
)

export default component.exports